module.exports = __webpack_public_path__ + "img/帮助中心管理.4ac4e527.png";